
import "./index.css";

import { BrowserRouter, Route, Routes } from "react-router";
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Pages from "./Pages";
import Lighthouse3rdParty from "./lighthouse-3rd-party/Lighthouse3rdParty";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export function App() {
  return (
    <BrowserRouter basename="/stuff">
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Routes>
          <Route index element={<Pages />} />
          <Route path="/lh-3rd-party" element={<Lighthouse3rdParty />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
